import React from "react";

const KpiCard = ({ value, icon, description, color = "#0d6efd" }) => {
  return (
    <div className="card shadow-sm border-0 h-100">
      <div className="card-body d-flex align-items-center gap-3">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle"
          style={{ width: 40, height: 40, backgroundColor: `${color}1a`, color }}
        >
          {icon}
        </div>
        <div>
          <div className="fw-bold fs-4 mb-0">{value}</div>
          <div className="text-muted small">{description}</div>
        </div>
      </div>
    </div>
  );
};

export default KpiCard;